import {webNet} from "../index";

// 查询证书信息的方法
export const queryCertificate = ({ queryInfo }) => {
	// 设置参数
	let params = new URLSearchParams()
	params.append('query_info', JSON.stringify(queryInfo))
	return webNet.request({
		params: {},
		data: params,
		method: 'post',
		url: '/web/qy/cer',
	})
}
